import { useQuery } from '@tanstack/react-query';
import { useContext, useEffect } from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { AppContext } from '../containers/appContextContainer';
import { SoeknadstypeWeb } from '../generated-types';
import errorTypes from '../util/gtm/errorTypes';
import restClient from '../util/web-http-client';

const redirectUrl = (): string => {
    const baseUrl = window.location.href.replace('samtykke', 'inntekt');
    return encodeURI(baseUrl).replace(/amp;/g, '');
};

const useSamtykke = (soeknadstype: SoeknadstypeWeb | null) => {
    const { setError } = useContext(AppContext);
    const query = useQuery({
        queryKey: ['samtykke'],
        queryFn: () => restClient.getSamtykkeUrl({ redirectURL: redirectUrl(), soeknadstypeWeb: soeknadstype }),
        retry: 1,
    });

    useEffect(() => {
        if (query.error) {
            setError({
                errorType: errorTypes.GET_SAMTYKKE_URL,
                errorException: query.error as RequestExceptionWithResponse,
            });
        }
    }, [query.error, setError]);

    return query;
};

export default useSamtykke;
